import { lazy } from 'react';

const AdvertiserNotContent = lazy(() => import('./AdvertiserNotContent'));;

export default { AdvertiserNotContent };
